import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=d39a6c70&scoped=true"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"
import style0 from "./StudentList.vue?vue&type=style&index=0&id=d39a6c70&prod&lang=less&scoped=true"
import style1 from "./StudentList.vue?vue&type=style&index=1&id=d39a6c70&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39a6c70",
  null
  
)

export default component.exports